


















import Vue from 'vue';

export default Vue.extend({
  name: 'VueD3Wrapper',
  props: {
    showExport: {
      type: Boolean,
      default: false,
    },
    onExportPng: Function,
  },
});
